import { useNavigate } from "react-router-dom";

export const RestaurantListCard = ({ restaurantList }) => {
  const navigate = useNavigate();
  const handleClick = () => navigate(`/restaurants/${restaurantList.sid}`);

  return (
    <li
      onClick={handleClick}
      className="card p-4 cursor-pointer hover:border-teal-600 flex items-center justify-between"
    >
      <span className="font-medium text-stone-800">{restaurantList?.name}</span>
      <span className="text-sm text-stone-500">{restaurantList?.type}</span>
    </li>
  );
};

const RestaurantListRow = ({ restaurantList }) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/restaurants/${restaurantList.sid}`);
  };
  return (
    <tr onClick={handleRowClick} className="cursor-pointer hover:bg-stone-100">
      <td className="px-3 py-2">{restaurantList?.name}</td>
      <td className="px-3 py-2">{restaurantList?.type}</td>
    </tr>
  );
};

export default RestaurantListRow;
